import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";

import Elements from "../Elements/Elements";
import "./StepEight.scss";
import Form from "../Form/Form";
import Formdate from "../Form/Formdate";
import Formarea from "../Form/Formarea";
import axios from "axios";
import { SquareContext } from "../../SquareContext";

export default function StepEight(props) {
  const {
    activeColor,
    nameForm,
    teleForm,
    mailForm,
    country,
    initialColor,
    day,
    month,
    year,
    stepDesc,
    cart,
    unity2,
    unity3,
  } = useContext(SquareContext);

  const [actColor, setActColor] = useState(initialColor);
  const [whichStone, setWhichStone] = useState();
  const [whichStone2, setWhichStone2] = useState();
  const [whichStone3, setWhichStone3] = useState();

  useEffect(() => {
    if (
      teleForm !== "" &&
      mailForm !== "" &&
      nameForm !== "" &&
      country !== "" &&
      day !== "" &&
      month !== "" &&
      year !== ""
    ) {
      setActColor(activeColor);
    } else {
      setActColor(initialColor);
    }
  }, [
    teleForm,
    mailForm,
    nameForm,
    country,
    day,
    month,
    year,
    activeColor,
    initialColor,
  ]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity3]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepEight">
      
        
        {stepDesc[7] && (
        <div>
          <div className="head">
            <p className="head-red">STEP 8</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[7].title }}></p>
          </div>
        </div>
      )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 8) {
                props.jump(1);
              } else {
                props.jump(8);
              }
            }}
            second={() => {
              if (props.order === 8) {
                props.jump(1);
              } else {
                props.jump(8);
              }
            }}
            third={() => {
              if (props.order === 8) {
                props.jump(1);
              } else {
                props.jump(8);
              }
            }}
          />
          {stepDesc[7] !== undefined && (
            <div className="text-middle"
            dangerouslySetInnerHTML={{ __html: stepDesc[7].description }}
            >
              {/* <Text
                desc={stepDesc[7] !== undefined && stepDesc[7].description}
              /> */}
            </div>
          )}
          <div className="buttons">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: activeColor }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={() => {
                  if (props.order === 8 && actColor === activeColor) {
                    // props.jump(1)

                    props.jump(9);
                  }
                }}
                style={{ background: actColor }}
              >
                NEXT STEP
              </button>
            </div>
        </div>
        <div className="shapes">
          <Elements eleclass="elements" />
          <div className="shapes-form-container-step8">
            <div className="shapes-form-step8">
              <div className="detail-line8">
                <div className="input-line8">
                  <div className="detail8">
                    <p>BASIC INFORMATION</p>
                    <hr></hr>
                  </div>
                  <Form />
                </div>
              </div>
            </div>
            <div className="shapes-form-step8">
              <div className="detail-line8">
                <div className="input-line8">
                  <div className="detail8">
                    <p>EXPECTED DATE OF INSTALLATION*</p>
                    <hr></hr>
                  </div>
                  <Formdate />
                </div>
              </div>
            </div>
            <div className="shapes-form-step8">
              <div className="detail-line8">
                <div className="input-line8">
                  <div className="detail8">
                    <p>ADDITIONAL INFORMATION</p>
                    <hr></hr>
                  </div>
                  <span className="please">
                  Please provide any additional information regarding the project. Or details should you require any custom designs.
                  </span>
                  <Formarea />
                </div>
              </div>
            </div>
            <div className="buttons btn-dwn8">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: activeColor }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={() => {
                  if (props.order === 8 && actColor === activeColor) {
                    // props.jump(1)

                    props.jump(9);
                  }
                }}
                style={{ background: actColor }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
       
      </div>
    </>
  );
}
